/* eslint-disable */
export default {
    ticket: {}
}